import React, { useState, useEffect, useMemo } from "react";
import api from "../../api/api";
import Select from "react-select";
import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

const SpareList = ({ User, TicketId ,ServiceId}) => {
  const [sparesList, setSparesList] = useState([]);
  const [dropdownData, setDropdownData] = useState({ allParts: [] });
  const [showModal, setShowModal] = useState(false);
  
  const [formData, setFormData] = useState({
    id: null,
    SeqId: null,
    ItemId: "",
    PartNo: "",
    PartDesc: "",
    UOM: "",
    ReqQty: 0,
    IssuedQty: 0,
    BalanceQty: 0,
  });

  useEffect(() => {
    const fetchParts = async () => {
      try {
        const userName = User || sessionStorage.getItem("userName");
        const actualTicketId = TicketId || "0"; 
        const response = await api.GetAllTicketService(userName, actualTicketId);

        const data = response?.Table4 || []; 
        setDropdownData({ allParts: data });
      } catch (err) {
        console.error("❌ Error fetching parts for dropdown:", err);
      }
    };

    if (User) fetchParts();
  }, [User, TicketId]);

 useEffect(() => {
  const fetchSavedSpares = async () => {

    const serviceId = ServiceId; 

    if (!serviceId || Number(serviceId) === 0) {
      console.log("No valid ServiceId provided for loading spares.");
      setSparesList([]); 
      return;
    }

    try {
      const response = await api.EditServicesparelistAPI(serviceId);
      console.log("response", response);

      const data = response?.Table || response?.data?.Table || [];

      const formatted = data.map((item, index) => ({
        id: item.SeqId || index + 1, 
        SeqId: item.SeqId,           
        ServiceId: item.ServiceId,
        ItemId: item.SpareId,
        PartNo: item.SparesUsed,
        PartDesc: item.Type,
        UOM: item.UOM,
        ReqQty: item.IssueQty,
        IssuedQty: item.UsedQty,
        BalanceQty: item.IssueQty - item.UsedQty,
      }));

      setSparesList(formatted);
      console.log("✅ Existing spares loaded:", formatted);
    } catch (err) {
      console.error("❌ Error loading saved spares:", err);
    }
  };

  fetchSavedSpares();
}, [ServiceId]); 

  const partOptions = useMemo(() => {
    return dropdownData.allParts.map((p) => ({
      value: p.Item_No,
      label: `${p.Item_No} - ${p.Item_Desc1}`,
      data: p,
    }));
  }, [dropdownData.allParts]);

  const handleAddClick = () => {
    setFormData({
      id: null,
       SeqId: sparesList.length + 1,
      ItemId: "",
      PartNo: "",
      PartDesc: "",
      UOM: "",
      ReqQty: 1, // Set default quantity to 1
      IssuedQty: 0,
      BalanceQty: 1, // Initial balance
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      id: null,
      ItemId: "",
      PartNo: "",
      PartDesc: "",
      UOM: "",
      ReqQty: 0,
      IssuedQty: 0,
      BalanceQty: 0,
    });
  };

 const handleChange = (e) => {
  // React-Select selection
  if (e && e.value && e.data) {
    const selectedPart = e.data;
    setFormData((prev) => ({
      ...prev,
      ItemId: selectedPart.ItemId,
      PartNo: selectedPart.Item_No,
      PartDesc: selectedPart.Item_Desc1,
      UOM: selectedPart.Uom,
    }));
    return;
  }

  // React-Select clear (e is null)
  if (e === null) {
    setFormData((prev) => ({
      ...prev,
      ItemId: "",
      PartNo: "",
      PartDesc: "",
      UOM: "",
    }));
    return;
  }

  // Normal input fields
  const { name, value } = e.target || {};

  if (name === "ReqQty" || name === "IssuedQty") {
    const newValue = Number(value);
    setFormData((prev) => {
      const updated = { ...prev, [name]: newValue };
      updated.BalanceQty = updated.ReqQty - updated.IssuedQty;
      return updated;
    });
  } else if (name) {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};

  const handleSave = async () => {

    const serviceId = ServiceId; 

    try {
      if (!serviceId || Number(serviceId) === 0) {
        alert("⚠️ ServiceId not found. Please save the service details (Service tab) first.");
        return;
      }
      
      if (!formData.PartNo) {
           alert("Please select a Part No.");
           return;
      }

      const payload = {
        ServiceId: serviceId, 
        SpareId: formData.ItemId,
        SparesUsed: formData.PartNo,
        UOM: formData.UOM,
        Type: formData.PartDesc,
        IssueQty: formData.ReqQty,
        UsedQty: formData.IssuedQty,
        Cost: formData.BalanceQty,
        Amount: 0,
        MId: "",
        MINo: "",
        MIDate: null,
        DeptName: "",
        deptid: "",
      };

      const response = await api.SaveServiceSpareAPI(payload);
      console.log("✅ Spare saved:", response);

      setSparesList((prev) => [...prev, { ...formData, id: Date.now(), ServiceId: serviceId }]);

      handleCloseModal();
    } catch (error) {
      console.error("❌ Error saving spare:", error);
      alert("Failed to save spare. Please try again.");
    }
  };

 const handleRemove = async (spare) => {
  try {
    const serviceId = ServiceId; 
    if (!serviceId || Number(serviceId) === 0) {
      alert("⚠️ ServiceId not found. Please save the service first.");
      return;
    }

    if (!spare.SeqId) {
      alert("⚠️ SeqId not found for this spare.");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this spare?")) {
      return;
    }
    const response = await api.DeleteSparelistAPI(serviceId, spare.SeqId); 
    setSparesList((prev) => prev.filter((s) => s.SeqId !== spare.SeqId));
    //alert("✅ Spare deleted successfully!");
  } catch (error) {
    console.error("❌ Error deleting spare:", error);
    alert("Failed to delete spare. Please try again.");
  }
};

  const selectedPartOption =
    partOptions.find((opt) => opt.value === formData.PartNo) || null;

  return (
    <div className="spares-list-container">
      {/* UPDATED HEADER LAYOUT */}
       <div className="header">
        <button className="btn-primary" onClick={handleAddClick}>
          + Add Spare
        </button>
        <ExcelExport data={sparesList} fileName="SpareList" />
        <h3>Spare Parts List</h3>
      </div>

      {sparesList.length > 0 ? (
        <table className="spares-table">
          <thead>
            <tr>
                 <th style={{ display: "none" }}>Seq</th>
                 <th>SlNo</th>
              <th>Part No</th>
              <th>Part Desc</th>
              <th>UOM</th>
              <th>Req Qty</th>
              <th>Issued Qty</th>
              <th>Balance Qty</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sparesList.map((spare,index) => (
              <tr key={spare.id}>
                
              <td style={{ display: "none" }}>{spare.SeqId}</td>
               <td>{index + 1}</td>
                <td>{spare.PartNo}</td>
                <td>{spare.PartDesc}</td>
                <td>{spare.UOM}</td>
                <td>{spare.ReqQty}</td>
                <td>{spare.IssuedQty}</td>
                <td>{spare.BalanceQty}</td>
                <td>
                  <button
                    className="btn-danger"
                    onClick={() => handleRemove(spare)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="placeholder-tab">
          No spares added yet. Click '+ Add Spare' to begin.
        </div>
      )}

      {/* 🔹 Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add Spare Details</h3> 

            <div className="modal-field">
              <label>Part No:</label>
<Select
  name="PartNo"
  value={selectedPartOption}
  onChange={handleChange}
  options={partOptions}
  placeholder="Search and Select Part No"
  isSearchable
  isClearable
  filterOption={(option, inputValue) => {
    const label = option.label || "";
    const desc = option.data?.Item_Desc1 || "";
    return (
      label.toLowerCase().includes(inputValue.toLowerCase()) ||
      desc.toLowerCase().includes(inputValue.toLowerCase())
    );
  }}
/>
            </div>

            <div className="modal-field">
              <label>Part Desc:</label>
              <input type="text" name="PartDesc" value={formData.PartDesc} readOnly />
            </div>

            <div className="modal-field">
              <label>UOM:</label>
              <input type="text" name="UOM" value={formData.UOM} readOnly />
            </div>

            <div className="modal-field">
              <label>Req Qty:</label>
              <input
                type="number"
                name="ReqQty"
                min="1"
                value={formData.ReqQty}
                onChange={handleChange}
              />
            </div>

            <div className="modal-field">
              <label>Issued Qty:</label>
              <input
                type="number"
                name="IssuedQty"
                min="0"
                value={formData.IssuedQty}
                onChange={handleChange}
              />
            </div>

            <div className="modal-field">
              <label>Balance Qty:</label>
              <input type="number" name="BalanceQty" readOnly value={formData.BalanceQty} />
            </div>

            <div className="modal-actions">
              <button className="btn-primary" onClick={handleSave}>
                Save
              </button>
              <button className="btn-secondary" onClick={handleCloseModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        /* --- PROFESSIONAL BASE STYLES --- */
        .spares-list-container {
          max-width: 900px;
          margin: 20px auto;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background: #ffffff;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

        /* Header Alignment */
        .header {
            display: flex;
            align-items: center;
            gap: 20px; 
            margin-bottom: 20px;
        }
        
        .header h3 {
            margin: 0;
            color: #1f3d7a; 
            font-size: 1.5rem;
            font-weight: 600;
        }

        /* Primary Button (Add) */
        .btn-primary {
          background-color: #007bff;
          color: white;
          padding: 8px 18px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-weight: 500;
          transition: background-color 0.2s;
          box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
        }
        .btn-primary:hover {
          background-color: #0056b3;
        }
        
        /* Secondary Button (Modal Cancel) */
        .btn-secondary {
            background-color: #6c757d;
            color: white;
            padding: 8px 14px;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            font-size: 14px;
        }
        .btn-secondary:hover {
            background-color: #5a6268;
        }

        /* Delete Button */
        .btn-danger {
          background-color: #dc3545;
          color: white;
          padding: 5px 10px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.9rem;
          transition: background-color 0.2s;
        }
        .btn-danger:hover {
          background-color: #c82333;
        }
        
        /* --- TABLE STYLES (MATCHING MAINTENANCE) --- */
        .spares-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            margin-bottom: 20px;
            border-radius: 8px;
            overflow: hidden; 
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        .spares-table th, .spares-table td {
            padding: 12px 15px;
            /* Changed from center to left for the new professional look, but kept center for data alignment if needed */
            text-align: center;
        }

        .spares-table th {
            background-color: #f1f5f9; 
            color: #333;
            font-weight: 600;
            border-bottom: 2px solid #e0e0e0;
        }
        
        /* Ensure table data cells align left for a cleaner look, except for numeric columns */
        .spares-table td:nth-child(2), /* SlNo */
        .spares-table td:nth-child(3), /* Part No */
        .spares-table td:nth-child(4) { /* Part Desc */
             text-align: left;
        }


        .spares-table td {
            border-bottom: 1px solid #eee;
        }

        .spares-table tbody tr:last-child td {
            border-bottom: none;
        }

        .spares-table tr:hover {
            background-color: #f8f9fa;
        }
        
        /* Placeholder */
        .placeholder-tab {
            text-align: center;
            color: #888;
            padding: 20px;
            font-style: italic;
            background: #f4f4f4;
            border-radius: 5px;
            margin-top: 15px;
        }


        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }
        .modal-content {
          background: white;
          padding: 20px;
          border-radius: 12px;
          width: 400px;
          max-width: 90%;
        }
        .modal-field {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
        }
        .modal-field label {
          margin-bottom: 4px;
          font-weight: 500;
        }
        .modal-field input {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 14px;
        }
        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 10px;
        }
      `}</style>
    </div>
  );
};

export default SpareList;